import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ActivityService } from '../proxy/controlling/controllers/activity.service';
import { ConsumableService } from '@general/proxy/general/controllers/consumable.service';

FieldBuilder.setNamespace('Controlling');

export const CONSUMABLEACCEPTEDPERACTIVITY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('acceptedQuantity', 'Entity.ConsumableAcceptedPerActivity.AcceptedQuantity')
    .required()
    .decimal(2,18)
    .build(),
  FieldBuilder
    .foreignKey('activityId', 'Entity.Activity', ActivityService)
    .required()
    .displayFromNested('activity.name')
    .sortBy('activity.name')
    .hideInChildForms()
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('consumableId', 'Entity.ConsumableAcceptedPerActivity.Consumable', ConsumableService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const CONSUMABLEACCEPTEDPERACTIVITY_CONFIG = {
  entityName: 'ConsumableAcceptedPerActivity',
  localizationKey: 'Controlling::Entity.ConsumableAcceptedPerActivity',
  fields: CONSUMABLEACCEPTEDPERACTIVITY_FIELDS,
  permission: 'ControllingActivities.ConsumableAcceptedPerActivities',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
